// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
/**
 * Horizontal Gallery button width in rem
 */
export const HORIZONTAL_GALLERY_BUTTON_WIDTH = 1.75;
/**
 * @private
 */
export const leftRightButtonStyles = (theme) => {
    return {
        background: 'none',
        padding: 0,
        height: '100%',
        minWidth: `${HORIZONTAL_GALLERY_BUTTON_WIDTH}rem`,
        maxWidth: `${HORIZONTAL_GALLERY_BUTTON_WIDTH}rem`,
        border: `1px solid ${theme.palette.neutralLight}`,
        borderRadius: theme.effects.roundedCorner4
    };
};
/**
 * Horizontal Gallery gap size in rem between tiles and buttons
 */
export const HORIZONTAL_GALLERY_GAP = 0.5;
/**
 * @private
 */
export const rootStyle = {
    height: '100%',
    width: '100%',
    gap: `${HORIZONTAL_GALLERY_GAP}rem`
};
/**
 * @private
 */
export const childrenContainerStyle = {
    height: '100%',
    gap: `${HORIZONTAL_GALLERY_GAP}rem`
};
//# sourceMappingURL=HorizontalGallery.styles.js.map